var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbTickTrue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#09A4D8",
    clipPath: "url(#ib-tick-true_svg__clip0_2746_21850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12.333A5.833 5.833 0 106 .667a5.833 5.833 0 000 11.666zM8.85 5.85a.73.73 0 00-1.032-1.031l-2.401 2.4-1.234-1.234A.73.73 0 103.15 7.016l1.75 1.75a.73.73 0 001.032 0l2.916-2.917z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12.333A5.833 5.833 0 106 .667a5.833 5.833 0 000 11.666zM8.85 5.85a.73.73 0 00-1.032-1.031l-2.401 2.4-1.234-1.234A.73.73 0 103.15 7.016l1.75 1.75a.73.73 0 001.032 0l2.916-2.917z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-tick-true_svg__clip0_2746_21850"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.167 .667)",
    d: "M0 0h11.667v11.667H0z"
  })))));
}

export default SvgIbTickTrue;